import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { Image } from '@components/atoms'
import useStyles from './match-play-player.styles'

const MatchPlayPlayer = (props) => {
  const {
    player,
  } = props
  const styles = useStyles()
  const imageReqParams = 'q_auto,c_fill,ar_1.2,w_300,g_face/'
  const [baseUrl, uniqueUrl] = player?.player?.headshot ? player.player.headshot.split('upload/') : []
  const baseUploadUrl = baseUrl && `${baseUrl}upload/`

  return (
    <Box className={styles.playerWrapper}>
      <Typography variant="subtitle1">
        {player.player.firstName.substring(0, 1)}. {player.player.lastName}
      </Typography>
      <Image
        src={baseUrl && uniqueUrl ? `${baseUploadUrl}${imageReqParams}${uniqueUrl}`
          : '/images/fallback-player.png'}
        alt="player photo"
      />
    </Box>
  )
}

MatchPlayPlayer.propTypes = {
  player: PropTypes.object,
}

export default MatchPlayPlayer
